const MAX_FLOW_JSON_BYTES = 1024 * 1024;

const countComponents = nodes =>
  nodes.reduce(
    (total, node) =>
      total +
      1 +
      countComponents(Array.isArray(node?.children) ? node.children : []),
    0
  );

export const parseFlowJson = source => {
  const text = typeof source === 'string' ? source.trim() : '';
  if (!text) throw new Error('Cole ou importe o JSON do Flow.');
  if (new Blob([text]).size > MAX_FLOW_JSON_BYTES) {
    throw new Error('O JSON do Flow deve ter no máximo 1 MB.');
  }

  let schema;
  try {
    schema = JSON.parse(text);
  } catch (error) {
    throw new Error(`JSON inválido: ${error.message}`);
  }

  if (!schema || Array.isArray(schema) || typeof schema !== 'object') {
    throw new Error('A raiz do Flow deve ser um objeto JSON.');
  }
  if (typeof schema.version !== 'string' || !schema.version.trim()) {
    throw new Error('O Flow precisa informar a propriedade version.');
  }
  if (!Array.isArray(schema.screens) || schema.screens.length === 0) {
    throw new Error('O Flow precisa conter ao menos uma tela em screens.');
  }

  const ids = new Set();
  schema.screens.forEach((screen, index) => {
    if (!screen?.id || typeof screen.id !== 'string') {
      throw new Error(`A tela ${index + 1} precisa ter um id.`);
    }
    if (ids.has(screen.id)) {
      throw new Error(`O id de tela ${screen.id} está duplicado.`);
    }
    ids.add(screen.id);
    if (screen.layout?.type !== 'SingleColumnLayout') {
      throw new Error(
        `A tela ${screen.id} precisa usar layout.type SingleColumnLayout.`
      );
    }
    if (!Array.isArray(screen.layout.children)) {
      throw new Error(`A tela ${screen.id} precisa conter layout.children.`);
    }
  });

  return schema;
};

export const getFlowSummary = schema => {
  if (!schema?.screens?.length) return null;

  return {
    version: schema.version,
    dataApiVersion: schema.data_api_version || null,
    screens: schema.screens.length,
    components: schema.screens.reduce(
      (total, screen) => total + countComponents(screen.layout.children),
      0
    ),
    terminalScreens: schema.screens.filter(screen => screen.terminal).length,
  };
};

export const getInitialFlowScreen = (schema, preferredScreenId) => {
  const screens = schema?.screens || [];
  return (
    screens.find(screen => screen.id === preferredScreenId) ||
    screens[0] ||
    null
  );
};

export const resolveFlowText = (value, data = {}) => {
  if (typeof value !== 'string') return value;

  return value.replace(
    /\$\{(?:screen\.[^.]+\.form|data)\.([^}]+)\}/g,
    (_, key) => {
      const resolved = data[key];
      return resolved === undefined || resolved === null
        ? ''
        : String(resolved);
    }
  );
};
